import React,{useState,useEffect} from 'react'
import '../App.css';
import HomeImage from '../Image/LeftLogo.png';
import Promote1 from '../Image/Promote1.png';
import axios from 'axios';
import Service1 from '../Image/Service1.png';
import Service2 from '../Image/Service2.png';
import Service3 from '../Image/Service3.png';
import Promote2 from '../Image/Promote2.png';
import cardIcon from '../icon/icons8-poker-96.png';


function Home() {
    //data get from php file
    const [data,setData] = useState([]);
    let counter =1;


    //connect to api to get result
    function connectPhp(){
        let data =[];
        axios.get("https://www.pta-hk.com/getRanking.php").then
        (response=>{
            data = response.data;
            setData(data);
            console.log(data);
        }).catch((e)=>console.log(e));
    }

    useEffect(()=>{
        connectPhp();
        console.log("Connecting.....");
    },[]);
   

    return (
    <div className="container">
        <div className="container-content">
            <div className="leftContainer">
                <img src ={HomeImage} 
                    alt="Poker Tournament Association"
                    className="HomeImage"
                />
            </div>
            <div className="rightContainer">
                <div className="table-container">
                    <div className="title">年度積分總排名 &nbsp;
                    <img src={cardIcon}
                    alt="Poker Tournament Association"
                    className="icon"/> 
                    </div>
                    <table className="data-table">
                    <thead>
                        <tr>
                            <th>排名</th>
                            <th>會員稱呼</th>
                            <th>積分</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item)=>(
                            <tr key={item.id} className="tableRowItem">
                                <td className="tableCell">{counter++}</td>
                                <td className="tableCell">{item.nickname}</td>
                                <td className="tableCell" id="tableTotal">{item.total}</td>
                            </tr>
                        ))}
                    </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div className="banner-section">
            <img src={ Promote1 }
                alt="Poker Tournament Association"
                className="bannerImage1"
            />
        </div>
        <div className="service-section">
            <div className="service">
                <a
                href="https://www.pta-hk.com/#/dealerCourse" 
                target="_blank"
                rel="nopener noreferrer"
                arial-label="Event"
                > 
               <img src={Service1}
                alt="Poker Tournament Association"
                className="service-image"
               /> 
               </a>        
            </div>
            <div className="service">
               <a
                href="https://www.pta-hk.com/#/skillCourse" 
                target="_blank"
                rel="nopener noreferrer"
                arial-label="Event"
                >  
                <img src={Service2}
                alt="Poker Tournament Association"
                className="service-image"
                /> 
               </a>        
            </div>
            <div className="service">
               <a
                href="https://www.pta-hk.com/#/event" 
                target="_blank"
                rel="nopener noreferrer"
                arial-label="Event"
                > 
                   <img src={Service3}
                    alt="Poker Tournament Association"
                    className="service-image"
                   />
               </a>         
            </div>
        </div>
        <div className="banner-section">
            <a
                href="https://www.pta-hk.com/#/booking" 
                target="_blank"
                rel="nopener noreferrer"
                arial-label="Event"
                >
            <img src={ Promote2 }
                alt="Poker Tournament Association"
                className="bannerImage2"
            />
            </a>
        </div>    
    </div>

   
    )
}

export default Home
